// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
export const trace = !import.meta.env.PROD ? (...args: any) => console.log('[src/index]', ...args) : () => {};
